import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { IUsuario } from '../nucleo/interface/dto/IUsuario';
import { EnvironmentService } from '../nucleo/configuracion/environment.service';
import { IResponseData } from '../nucleo/interface/dto/IResponseData';

@Injectable()
export class AuthApiService {

  constructor(private http: HttpClient, private configService: EnvironmentService) { }

  login(path: string, usuario: IUsuario): Observable<HttpResponse<IResponseData>> {
    return this.http.post<HttpResponse<IResponseData>>(
      `${this.configService.webCoreServicio}:${this.configService.webCorePuerto}/${path}/login`,
      usuario, {observe: 'response' as 'body'});
  }

  logout(path: string, usuario: IUsuario): Observable<IResponseData> {
    return this.http.post<IResponseData>(
      `${this.configService.webCoreServicio}:${this.configService.webCorePuerto}/${path}/logout`,
      usuario);
  }

  cambiarIniPass(path: string, usuario: IUsuario): Observable<any> {
    return this.http.post<any>(
      `${this.configService.webCoreServicio}:${this.configService.webCorePuerto}/${path}/cambiarIniPass`,
      usuario);
  }

  cambiarPass(path: string, usuario: IUsuario): Observable<any> {
    return this.http.post<any>(
      `${this.configService.webCoreServicio}:${this.configService.webCorePuerto}/${path}/cambiarPass`,
      usuario);
  }
}
